export default "__VITE_ASSET__Bf3p9Ulk__"